export function contractExpiry(endDate: string, now = new Date()): 'expired' | 'expiring' | 'active' {
  const days = (new Date(endDate).getTime() - now.getTime()) / 86400000;
  return days < 0 ? 'expired' : days <= 30 ? 'expiring' : 'active';
}
